import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]


   
export default /*@__PURE__*/_defineComponent({
  __name: 'BenchlingIcon',
  props: {
        width: {
            type: String,
            default: '0.8em'
        },
        height: {
            type: String,
            default: '0.8em'
        },
   },
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: __props.width,
    height: __props.height,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    fill: "white",
    class: "_f9e8qy _1oubpp0",
    "data-test-component": "BenchlingIcon",
    "data-test-key": "benchling"
  }, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("defs", null, [
      _createElementVNode("path", {
        d: "M4.603 7.17c-.826-.237-2.054-.548-4.253-.753A.381.381 0 0 1 .01 6.12a.382.382 0 0 1 .18-.415C.197 5.7.604 5.313.924 4.5c.037-.093.08-.257.128-.445C1.355 2.86 2.072.069 5.738.069c3.667 0 4.382 2.792 4.688 3.986.049.188.091.352.128.445.318.813.727 1.2.733 1.204a.383.383 0 0 1 .177.415.379.379 0 0 1-.339.298c-2.269.212-3.504.537-4.33.776v.001c-.516.153-.795.267-.998.35l-.053.022c-.877.325-2.04.924-2.04 2.348 0 1.422 1.157 2.021 2.034 2.347.877-.326 2.035-.925 2.035-2.347 0-.835-.392-1.475-1.2-1.956L6.51 7.92l.072-.025c.271-.09.586-.18.935-.265l.017-.004.014.011c.706.6 1.063 1.366 1.063 2.277 0 1.223-.633 2.172-1.882 2.824a6.541 6.541 0 0 1-.85.365c-.042.014-.085.03-.128.046-.879.325-2.046.923-2.046 2.35a.42.42 0 1 1-.837 0c0-1.201.613-2.14 1.824-2.792-1.21-.65-1.825-1.59-1.825-2.793 0-1.173.584-2.096 1.737-2.744Zm3.588 8.75a.42.42 0 0 1-.418-.42c0-.836-.393-1.476-1.201-1.957l-.058-.035.061-.027c.277-.12.534-.252.768-.395l.02-.012.018.014c.816.618 1.23 1.43 1.23 2.412a.42.42 0 0 1-.42.42Zm-3.773-.87a1.49 1.49 0 0 1 .463-.67h1.714c.229.198.381.42.463.67h-2.64Zm0-5.585c.082-.251.234-.472.463-.67h1.714c.229.198.381.419.463.67h-2.64Zm2.64.968a1.49 1.49 0 0 1-.462.67H4.88a1.49 1.49 0 0 1-.463-.67h2.64Zm.544-6.135a.49.49 0 1 0 .981-.001.49.49 0 0 0-.981 0Zm-4.707 0a.49.49 0 1 0 .979.002.49.49 0 0 0-.98-.002Z",
        id: "benchling-logo_svg__a"
      })
    ], -1),
    _createElementVNode("use", {
      "xlink:href": "#benchling-logo_svg__a",
      transform: "translate(2.227)"
    }, null, -1)
  ]))], 8, _hoisted_1))
}
}

})